import { ref } from 'vue';

const globalAbortController = ref<AbortController | null>(null);

export default function () {
  function cancelAllRequests() {
    if (globalAbortController.value) {
      globalAbortController.value.abort();
      globalAbortController.value = null;
    }
  }

  function createNewController() {
    globalAbortController.value = new AbortController();
    return globalAbortController.value;
  }

  function getCurrentController() {
    return globalAbortController.value;
  }

  return {
    cancelAllRequests,
    createNewController,
    getCurrentController,
  };
}
